import { j as i } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as o } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const a = o((c, s) => /* @__PURE__ */ i.jsx(
  r,
  {
    ref: s,
    ...c,
    image: (t) => /* @__PURE__ */ i.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...t,
        children: [
          /* @__PURE__ */ i.jsx(
            "path",
            {
              stroke: "currentColor",
              strokeMiterlimit: 10,
              d: "M39.334 23.962c.065-.479.117-.97.155-1.462.622-8.346-2.031-15.063-9.627-17.25-.479-.142-.97-.258-1.488-.349-.194-.039-.401-.065-.595-.103a32 32 0 0 0-1.243-.169c-.194-.025-.388-.038-.582-.051a23 23 0 0 0-1.928-.078c-.673 0-1.307.039-1.928.078-.194.013-.388.038-.582.051-.428.04-.842.104-1.243.169-.207.038-.401.064-.595.103-.518.104-1.01.22-1.488.35C10.568 7.437 7.915 14.154 8.536 22.5c.04.492.09.983.156 1.462 0 0-2.705-1.734-2.692 1.333.013 2.99 2.834 4.568 4.387 4.8 1.747 3.948 4.555 6.924 7.893 8.529v.025c.143.065.298.13.44.195.181.077.35.155.544.233.466.18.932.349 1.423.478.13.04.233.104.285.22.246.492 1.139 1.592 1.63 2.032.065.052.117.09.169.142.414.35.815.53 1.229.518.414 0 .828-.181 1.23-.518.051-.051.116-.09.168-.142.491-.453 1.384-1.553 1.63-2.032.052-.116.168-.18.285-.22.479-.13.957-.297 1.423-.478.181-.065.363-.156.544-.233.142-.065.297-.117.44-.195v-.025c3.338-1.618 6.146-4.581 7.893-8.528 1.553-.233 4.374-1.812 4.387-4.8.013-3.068-2.692-1.334-2.692-1.334z"
            }
          ),
          /* @__PURE__ */ i.jsx(
            "path",
            {
              fill: "#1D1D42",
              d: "M24.013 4.5c-13.924 0-15.748 8.942-15.748 15.386 0 8.994 4.283 14.894 6.34 16.279-1.113-1.32-1.772-5.538.143-7.053 2.497-1.966 5.745 4.116 9.252 4.116s6.755-6.083 9.252-4.116c1.915 1.515 1.256 5.72.143 7.053 2.057-1.385 6.34-7.285 6.34-16.279 0-6.457-1.824-15.386-15.748-15.386z"
            }
          ),
          /* @__PURE__ */ i.jsx(
            "path",
            {
              fill: "#9CA9FF",
              d: "M19.742 6.583c6.936-1.876 14.985 2.925 16.784 7.985-5.681-4.115-10.987-6.833-16.784-7.985M25.798 29.23c-5.952-.04-9.757-2.136-11.685-7.001 3.947 2.924 6.923 4.36 11.685 7"
            }
          ),
          /* @__PURE__ */ i.jsx(
            "path",
            {
              fill: "#fff",
              d: "M16.417 14.283c5.991 1.488 11.374 4.827 16.11 8.735-5.797-2.161-10.96-5.37-16.11-8.735M20.48 11.164c6.65.065 12.345 5.448 14.984 11.245-4.451-4.594-8.864-9.084-14.984-11.245M21.632 14.503c2.29-.401 4.568 1.216 5.68 3.132-1.811-1.295-3.493-2.601-5.68-3.132M32.528 25.502c-2.627-.181-5.112-1.682-6.716-3.727 2.212 1.385 4.348 2.679 6.716 3.727M28.335 25.502c-6.043-.44-11.49-4.503-14.777-9.434 4.84 3.494 9.343 6.975 14.777 9.434"
            }
          )
        ]
      }
    )
  }
));
a.displayName = "HairThinningIcon";
export {
  a as HairThinningIcon,
  a as default
};
//# sourceMappingURL=index.js.map
